<template>
    <div :class="[clearbg ? 'tabbg' : '']">
        
        <v-tabs
            v-model="tab"
            centered
            color="primary"
            icons-and-text
            style="display:none"
        >
            <v-tab key="jobs"
            active-class="tabSearchActive">
                Jobs
                <v-icon>mdi-account-hard-hat</v-icon>
            </v-tab>

            <v-tab key="courses"
            active-class="tabSearchActive">
                Courses
                <v-icon>mdi-book-open-variant</v-icon>
            </v-tab>
        </v-tabs>
        <div class="tab-switch pt-5">
            <v-btn :x-large="!isPhone" :large="isPhone" :color="tab == 0 ? 'primary' : 'secondary'" @click="setTab(0)"><v-icon left>mdi-account-hard-hat</v-icon>Job Board</v-btn>
            <v-btn :x-large="!isPhone" :large="isPhone" :color="tab == 1 ? 'primary' : 'secondary'" @click="setTab(1)"><v-icon left>mdi-book-open-variant</v-icon>Courses</v-btn>
        </div>
        <v-tabs-items v-model="tab">
            <v-tab-item key="jobs">
                <JobSearchContainer :advanced="false" :baseurl="baseurl" :locations="locations" :categories="categories" :startKeyword="startKeyword" :startLocation="startLocation" :startCategory="startCategory"></JobSearchContainer>
            </v-tab-item>
            <v-tab-item key="courses">
                <CourseSearchContainer :baseurl="baseurl" :locations="locations" :categories="categories" :startKeyword="startKeyword" :startLocation="startLocation" :startCategory="startCategory"></CourseSearchContainer>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import JobSearchContainer from './JobSearchContainer.vue'
import CourseSearchContainer from './CourseSearchContainer.vue'
  
  export default {
    props: {
      locations: Array,
      baseurl: String,
      startKeyword: String,
      startLocation: String,
      startCategory: String,
      startTab: String,
      categories: Array,
      startOpen: Boolean,
      startTab: String,
      clearbg: Boolean
    },
    components: {
    JobSearchContainer,
    CourseSearchContainer
},
    computed: {
        isPhone() {
            return this.$vuetify.breakpoint.xsOnly;
        },
    },
    data() {
        return {
            tab: this.startTab && this.startTab == "courses" ? 1 : 0,
            keyword: "",
            location: "",
            category: "",
        }
    },
    methods: {
        setTab(x) {
            this.tab = x;
        },
        searchJobs() {
        this.$inertia.get(this.baseurl+'/search/job', {keyword: this.keyword, location: this.location, category: this.category}, {

        }) 
        },
        searchCourses() {
        this.$inertia.get(this.baseurl+'/search/course', {keyword: this.keyword, location: this.location, category: this.category}, {

        }) 
        }
    }
  }
  </script>

<style scoped type="text/css">

/* The two buttons are taller than the line box they sat in, so when they
   wrapped they touched with no gap and read as one overlapping the other.
   Flex gives them a real gap and keeps both lines centred; the first button
   no longer carries a 40px margin that pushed line one off centre. */
.tab-switch {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
}
/* Keep the desktop spacing exactly as it was: the 40px mr-10, plus the 4px
   whitespace between the two inline buttons that flex no longer renders. */
@media (min-width: 600px) {
    .tab-switch {
        gap: 44px;
    }
}


.tabbg {
    background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),url(https://backtoworkconnect.ie/img/cover.webp);
    background-size: cover;
    background-position: center;
    color:white;
}

.tabbg .v-tabs-bar {
    background:rgba(250,250,250,0) !important;
}
.tabbg  .v-tabs-items { 
    background:rgba(250,250,250,0) !important;
}
</style> 